import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "password-advanced-walidator"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LayoutTitle = _resolveComponent("LayoutTitle")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ValidationErrors = _resolveComponent("ValidationErrors")!
  const _component_ElFormItem = _resolveComponent("ElFormItem")!
  const _component_PasswordRuleMet = _resolveComponent("PasswordRuleMet")!
  const _component_ElOption = _resolveComponent("ElOption")!
  const _component_ElSelect = _resolveComponent("ElSelect")!
  const _component_ElForm = _resolveComponent("ElForm")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LayoutTitle, null, {
      title: _withCtx(() => [
        _createTextVNode("Welcome " + _toDisplayString(_ctx.firstName) + " " + _toDisplayString(_ctx.lastName), 1)
      ]),
      subtitle: _withCtx(() => _cache[8] || (_cache[8] = [
        _createTextVNode("Please create a password.")
      ])),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_ElForm, {
      ref: "form",
      onSubmit: _ctx.submitForm,
      class: "set-credentials-form",
      novalidate: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ElFormItem, {
          label: "Create Password",
          class: "label-on-top password-field"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ElInput, {
              placeholder: "Enter password",
              modelValue: _ctx.credentials.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.credentials.password) = $event)),
              onChange: _ctx.v$.credentials.password.$touch,
              onInput: _ctx.v$.credentials.password.$touch,
              onKeyup: _cache[2] || (_cache[2] = 
          () => {
            _ctx.passwordError = false;
          }
        ),
              ref: _ctx.passwordRefs.PASSWORD,
              type: _ctx.inputTypes.PASSWORD,
              class: _normalizeClass({ 'input-error': _ctx.v$.credentials.password.$error })
            }, {
              suffix: _withCtx(() => [
                _createVNode(_component_ElButton, {
                  class: "icon-password",
                  "aria-label": _ctx.showHidePasswordLabels.SHOW,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePassword(_ctx.passwordRefs.PASSWORD, $event)))
                }, null, 8, ["aria-label"])
              ]),
              _: 1
            }, 8, ["modelValue", "onChange", "onInput", "type", "class"]),
            _createVNode(_component_ValidationErrors, {
              errors: _ctx.v$.credentials.password.$errors,
              singleValidator: "passwordServerError"
            }, null, 8, ["errors"])
          ]),
          _: 1
        }),
        (_ctx.v$.credentials.password.$dirty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (!_ctx.v$.credentials.password.maxLength.$response)
                ? (_openBlock(), _createBlock(_component_ValidationErrors, {
                    key: 0,
                    errors: [_ctx.v$.credentials.password.maxLength]
                  }, null, 8, ["errors"]))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: _normalizeClass(["password-advanced-walidator__text", {
          'password-advanced-walidator__text--valid':
            !!_ctx.credentials.password &&
            _ctx.v$.credentials.password.minLength.$response &&
            _ctx.v$.credentials.password.hasLowercaseLetter.$response &&
            _ctx.v$.credentials.password.hasUppercaseLetter.$response &&
            _ctx.v$.credentials.password.hasNumber.$response &&
            _ctx.v$.credentials.password.passwordDoesntContainPartsOfUsername
              .$response,
          'password-advanced-walidator__text--invalid': !(
            !!_ctx.credentials.password &&
            _ctx.v$.credentials.password.minLength.$response &&
            _ctx.v$.credentials.password.hasLowercaseLetter.$response &&
            _ctx.v$.credentials.password.hasUppercaseLetter.$response &&
            _ctx.v$.credentials.password.hasNumber.$response &&
            _ctx.v$.credentials.password.passwordDoesntContainPartsOfUsername
              .$response
          ),
        }])
              }, " Your password needs to include: ", 2),
              _createVNode(_component_PasswordRuleMet, {
                msg: "At least 8 characters",
                met: 
          !!_ctx.credentials.password && _ctx.v$.credentials.password.minLength.$response
        
              }, null, 8, ["met"]),
              _createVNode(_component_PasswordRuleMet, {
                msg: "A lowercase letter",
                met: 
          !!_ctx.credentials.password &&
          _ctx.v$.credentials.password.hasLowercaseLetter.$response
        
              }, null, 8, ["met"]),
              _createVNode(_component_PasswordRuleMet, {
                msg: "An uppercase letter",
                met: 
          !!_ctx.credentials.password &&
          _ctx.v$.credentials.password.hasUppercaseLetter.$response
        
              }, null, 8, ["met"]),
              _createVNode(_component_PasswordRuleMet, {
                msg: "A number",
                met: 
          !!_ctx.credentials.password && _ctx.v$.credentials.password.hasNumber.$response
        
              }, null, 8, ["met"]),
              _createVNode(_component_PasswordRuleMet, {
                msg: "No parts of username",
                met: 
          !!_ctx.credentials.password &&
          _ctx.v$.credentials.password.passwordDoesntContainPartsOfUsername.$response
        
              }, null, 8, ["met"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ElFormItem, { class: "password-field" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElInput, {
              placeholder: "Repeat password",
              modelValue: _ctx.credentials.repeatedPassword,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.credentials.repeatedPassword) = $event)),
              onChange: _ctx.v$.credentials.repeatedPassword.$touch,
              onInput: _ctx.v$.credentials.repeatedPassword.$touch,
              ref: _ctx.passwordRefs.REPEATED,
              type: _ctx.inputTypes.PASSWORD,
              class: _normalizeClass({ 'input-error': _ctx.v$.credentials.repeatedPassword.$error })
            }, {
              suffix: _withCtx(() => [
                _createVNode(_component_ElButton, {
                  class: "icon-password",
                  "aria-label": _ctx.showHidePasswordLabels.SHOW,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.togglePassword(_ctx.passwordRefs.REPEATED, $event)))
                }, null, 8, ["aria-label"])
              ]),
              _: 1
            }, 8, ["modelValue", "onChange", "onInput", "type", "class"]),
            _createVNode(_component_ValidationErrors, {
              errors: _ctx.v$.credentials.repeatedPassword.$errors
            }, null, 8, ["errors"])
          ]),
          _: 1
        }),
        _createVNode(_component_ElFormItem, {
          class: "label-on-top",
          label: "Choose a security question"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ElSelect, {
              modelValue: _ctx.credentials.recoveryQuestion,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.credentials.recoveryQuestion) = $event)),
              placeholder: "Select question",
              class: "full-width"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recoveryQuestions, (q) => {
                  return (_openBlock(), _createBlock(_component_ElOption, {
                    key: q,
                    label: q.questionText,
                    value: q.questionText
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_ElFormItem, { class: "no-bottom-margin" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElInput, {
              placeholder: "Enter the answer",
              modelValue: _ctx.credentials.answer,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.credentials.answer) = $event)),
              onChange: _ctx.v$.credentials.answer.$touch,
              onKeyup: _cache[7] || (_cache[7] = 
          () => {
            _ctx.answerError = false;
          }
        ),
              type: "text",
              class: _normalizeClass({ 'input-error': _ctx.v$.credentials.answer.$error })
            }, null, 8, ["modelValue", "onChange", "class"]),
            _createVNode(_component_ValidationErrors, {
              single: true,
              errors: _ctx.v$.credentials.answer.$errors
            }, null, 8, ["errors"])
          ]),
          _: 1
        }),
        _createVNode(_component_ElFormItem, { class: "no-top-margin" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElButton, {
              "native-type": "submit",
              class: "submit-btn",
              disabled: _ctx.v$.credentials.$error
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Save")
              ])),
              _: 1,
              __: [9]
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onSubmit"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ], 64))
}